export default __webpack_public_path__ + "static/media/bull_new.b56c47ab.svg";